import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import './style.less';

class RulesPage extends Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <DocumentTitle title={'第2教室服务使用协议'}>
                <div className="container customerrules">
                    <h1>《第2教室服务使用协议》</h1>
                    <p>
                    本《第2教室服务使用协议》是您（以下称“用户”）与杭州潘哒教育科技有限公司（以下简称“管理公司”）之间在使用其管理的第2教室平台（以下简称“第2教室”）中注册使用时签署的协议。
                    </p>
                    <h3>一、重要须知</h3>
                    <p>
                    用户应认真阅读（未成年人应当在监护人陪同下阅读）、充分理解本协议中各条款。除非用户接受本协议，用户应当立即停止注册及使用行为。
                    </p>
                    <p>
                    用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
                    </p>
                    <p>
                    用户注册成功后，第2教室将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户妥善保管帐号和密码，防止泄露，如果帐号和密码被盗用的，用户应当对以其用户帐号进行的所有活动和事件负法律责任。
                    </p>
                    <h3>二、服务内容</h3>
                    <p>
                    1、第2教室服务的具体内容由第2教室根据实际情况提供。
                    </p>
                    {/* <p>
                    2、第2教室提供的部分服务（例如购买课时等）为收费服务，用户使用收费服务需要向第2教室支付一定的费用。对于收费服务，第2教室会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费服务。如用户拒绝支付相关费用，则第2教室有权不向用户提供该等收费服务。
                    </p> */}
                    <p>
                    2、用户理解，第2教室仅提供软件相关服务，除此之外与相关软件服务有关的设备（如手机、个人电脑及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。
                    </p>
                    <p>
                    3、用户同意第2教室为本协议履行或相关研究的目的收集、使用或授权第三方（且该等第三方同意承担与第2教室同等的个人信息保护义务）非商业地使用通过服务获取的用户信息（包括但不限于身份信息、性别、职业、兴趣爱好、在第2教室中形成的录音等语音资料），包括但不限于使用于排行榜上，使第2教室其他用户可以查看用户的头像、名字、语音等个人资料、应用于相关学术、应用研究等。第2教室承诺，除非另行取得用户的事先同意，否则第2教室不会将用户信息授权给与履行本协议无关的第三方用于商业目的。
                    </p>
                    <p>
                    4、根据相关法律法规及国家标准，在以下情形中，第2教室可能会依法收集并使用用户的个人信息并且无需征得用户的同意:
                        <span>（1）与国家安全、国防安全直接相关的；</span>
                        <span>（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
                        <span>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
                        <span>（4）出于维护用户或他人的生命、财产等重大合法权益但又很难得到用户本人同意的；</span>
                        <span>（5）所收集的个人信息是用户自行向社会公众公开的；</span>
                        <span>（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</span>
                        <span>（7）根据用户的要求签订和履行合同所必需的；</span>
                        <span>（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</span>
                        <span>（9）为合法的新闻报道所必需的；</span>
                        <span>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
                        <span>（9）法律法规规定的其他情形。</span>
                    </p>
                    <p>
                    5、在以下情形中，第2教室向第三方提供用户的个人信息无需事先征得用户的授权同意：
                    <span>（1）与国家安全、国防安全有关的；</span>
                    <span>（2）与公共安全、公共卫生、重大公共利益有关的；</span>
                    <span>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</span>
                    <span>（4）出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
                    <span>（5）用户自行向社会公众公开的个人信息；</span>
                    <span>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
                    </p>
                    <h3>三、用户规则</h3>
                    <p>
                    1、用户注册成功后，用户有权使用第2教室软件功能与用户进行分享交流，包括课程学习、发帖教学、歌曲演唱以及分享其他一切用户感兴趣的内容。
                    </p>
                    <p>
                    2、用户有权使用第2教室提供的个人主页、照片上传、分享个人信息。
                    </p>
                    <p>
                    3、用户在使用第2教室时须遵守国家相关法律法规，不得从事以下行为，包括但不限于：
                        <span>3.1 发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽或含有任何性或性暗示的、暴力的内容；</span>
                        <span>3.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</span>
                        <span>3.3 发布、传送、传播、储存涉及他人隐私、个人信息或资料的；</span>
                        <span>3.4 发表、传送、传播骚扰、广告信息及垃圾信息；</span>
                        <span>3.5 其他违反法律法规、政策及公序良俗、社会公德或干扰平台正常运营和侵犯其他用户或第三方合法权益内容的信息。</span>
                    </p>
                    <p>
                    4、用户必须清楚使用规则，第2教室仅供个人交流、学习欣赏，非商业性质的使用，用户不可利用本服务对信息或表演等知识产权内容进行出售、或利用本服务进行调查、广告、或用于其他商业目的。
                    </p>
                    <p>
                    5、 用户保证在使用第2教室时发布、传播的信息的真实性、准确性，保证不得发布谣言或其他与事实不符引起他人不适的言论、信息。
                    </p>
                    <p>
                    6、用户保证在使用第2教室不得发布、传播侵犯知识产权或其他合法权益的信息。用户传播内容中涉及第三方拥有知识产权内容的相关授权或其他内容的合法性由用户自行负责，第2教室对相关内容的知识产权权属或是否侵犯他人民事权益等情况不进行审查或监督，但将按相关法规对涉嫌侵权的内容履行删除或断开链接等职责。
                    </p>
                    <p>
                    7、若用户发生前述3-6的行为时，由用户承担所有的违法、侵权责任，若因此给第2教室造成任何损失，第2教室有权向责任用户主张相关责任。同时，第2教室有权对违法、侵权、违规的用户终止提供服务。如果政府或者司法机关要求第2教室告知进行侵权行为用户的具体信息的，第2教室有权根据现行法规向其告知用户信息。
                    </p>
                    <p>
                    8、用户同意第2教室有权在提供服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息，并且，用户同意接受第2教室通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。
                    </p>
                    <h3>四、知识产权</h3>
                    <p>
                    1、用户在使用第2教室分享个人作品时，不得侵犯第三方任何知识产权。
                    </p>
                    <p>
                    2、用户使用第2教室分享信息中含有的完全由用户自身原创信息的版权归用户，但其中利用第2教室而形成的录音或其他资料，利用第2教室中已有素材而形成的录音或其他资料的版权由用户与第2教室共有。用户的分享行为是对其享有版权或经合法授权的相关内容的网络传播行为许可，用户的分享行为即表明其已授权第2教室及其他用户有权复制、传播前述信息。
                    </p>
                    <h3>五、服务变更、中断或终止</h3>
                    <p>
                    1、鉴于服务的特殊性，用户同意第2教室有权随时变更、中断或终止部分或全部的服务（包括收费服务及免费服务）。如变更、中断或终止的服务属于免费服务，第2教室无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的服务属于收费服务，第2教室应当在变更、中断或终止之前事先通知用户，并应向受影响的用户提供等值的替代性的收费服务，如用户不愿意接受替代性的收费服务，就该用户已经向第2教室支付的服务费，第2教室应当按照该用户实际使用相应收费服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。
                    </p>
                    <p>
                    2、用户理解，第2教室需要定期或不定期地对提供服务的平台或相关的设备进行检修或者维护，如因此类情况而造成收费服务在合理时间内的中断，第2教室无需为此承担任何责任，但第2教室应尽可能事先进行通告。
                    </p>
                    <p>
                    3、如用户注册的免费服务的帐号在任何连续90日内未实际使用，或者在提示用户需在10日内投入实际使用后，若用户于该10日内仍未实际使用，则第2教室有权删除该帐号并停止为该用户提供相关的服务。
                    </p>
                    <p>
                    4、用户注册的免费帐号昵称如存在违反法律法规、国家政策要求、第2教室的昵称管理要求，或侵犯任何第三方合法权益的情况，第2教室有权要求用户进行修改或收回该账号昵称。
                    </p>
                    <h3>六、其他事宜</h3>
                    <p>
                    1、第2教室有权根据法律法规的变化、网站以及相应的第2教室运营的需要不时地对本协议及本站的内容进行修改，并在网站以及第2教室醒目位置张贴。修改后的协议一旦被张贴在本站上即生效，并代替原来的协议，用户可随时登录查阅最新协议。用户有义务及时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以立即向第2教室进行反馈且应立即停止接受第2教室依据本协议提供的服务；如用户继续使用本站提供的服务的，即视为同意更新后的协议。
                    </p>
                    <p>
                    2、本协议自用户点击“同意”、“接受”后生效。
                    </p>
                    <p>
                    3、本协议所有条款的标题仅为方便而设,不具法律或契约效果。
                    </p>
                    <p>
                    4、本协议的解释权归第2教室所有。
                    </p>
                </div>
            </DocumentTitle>
        )
    }
}

export default RulesPage;



// WEBPACK FOOTER //
// ./src/components/customerPage/RulesPageOMO.jsx